import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// import_export.review — full-page error-first Review & Fix screen for an
// import run. Bound to the seeded `ir.action` (client_component=
// "import_export.review"); navigated to after upload with the run uuid as the
// trailing param. Discovered at boot by the eager glob in
// clientActionsDiscovery.ts. Lazy-loaded so it stays out of the initial bundle.
const ImportReview = lazyWithRetry(() => import("../components/ImportReview"), "import_export.review");

const plugin: ClientActionDescriptor = {
    key: "import_export.review",
    component: ImportReview,
    paramSchema: "uuid",
};

export default plugin;
